import React from "react";
import { useMutation } from "react-query";
import { useRequest } from "../contexts/request";

const useCheckReward = () => {
  const { post } = useRequest();

  const checkReward = async (
      streamerName,
      { from, email, phone, ...formValues },
    ) => {
      try {
        const { json } = await post(`reward/check-eligible/${streamerName}`, {
          json: {
            ...formValues,
            customer_info: { first_name: from, email, phone },
          },
        });
        return json.data?.is_eligible;
      } catch (error) {
        return false;
      }
    };
    return { checkReward };
};

export default useCheckReward;
